export default "__VITE_PUBLIC_ASSET__7075ff16__"